import ActionMap from 'common/js/helpers/ActionMap';
import Dispatcher from 'common/js/dispatcher/Dispatcher';

export const ActionTypes = {
    SET_LICENSE_NUMBER: 'SET_LICENSE_NUMBER',
    SET_SELECTED_SERVICE: 'SET_SELECTED_SERVICE',
    SET_HOTEL: 'SET_HOTEL',

    SET_SELECTED_SHOP: 'SET_SELECTED_SHOP',
    SET_SELECTED_SLOT: 'SET_SELECTED_SLOT',

    SET_SHOPS: 'SET_SHOPS',

    SET_TIME_IS_UP: 'SET_TIME_IS_UP',
};

export const Actions = ActionMap({
    setLicenseNumber(data) {
        Dispatcher.handleViewAction({
            actionType: ActionTypes.SET_LICENSE_NUMBER,
            payload: data,
        });
    },
    setSelectedService(data) {
        Dispatcher.handleViewAction({
            actionType: ActionTypes.SET_SELECTED_SERVICE,
            payload: data,
        });
    },
    setHotel(data) {
        Dispatcher.handleViewAction({
            actionType: ActionTypes.SET_HOTEL,
            payload: data,
        });
    },

    setSelectedShop(data) {
        Dispatcher.handleViewAction({
            actionType: ActionTypes.SET_SELECTED_SHOP,
            payload: data,
        });
    },

    setSelectedSlot(data) {
        Dispatcher.handleViewAction({
            actionType: ActionTypes.SET_SELECTED_SLOT,
            payload: data,
        });
    },

    setShops(data) {
        Dispatcher.handleViewAction({
            actionType: ActionTypes.SET_SHOPS,
            payload: data,
        });
    },

    setTimeIsUp(data) {
        Dispatcher.handleViewAction({
            actionType: ActionTypes.SET_TIME_IS_UP,
            payload: data,
        });
    },
});


/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/actions.js
 **/